import React from 'react';
import PropTypes from "prop-types";
export var EuiTreeViewNode = () => <div />;
EuiTreeViewNode.propTypes = {
  /** An array of EuiTreeViewNodes to render as children
     */
  children: PropTypes.arrayOf(PropTypes.shape({
    /** An array of EuiTreeViewNodes to render as children
       */
    children: PropTypes.arrayOf(PropTypes.any.isRequired),

    /** The readable label for the item
       */
    label: PropTypes.string.isRequired,

    /** A unique ID
       */
    id: PropTypes.string.isRequired,

    /** An icon to use on the left of the label
       */
    icon: PropTypes.element,

    /** Display a differnt icon when the item is expanded.
      For instance, an open folder or a down arrow
      */
    iconWhenExpanded: PropTypes.element,

    /** Use an empty icon to keep items without an icon
      lined up with their siblings
      */
    useEmptyIcon: PropTypes.bool,

    /** Whether or not the item is expanded.
       */
    isExpanded: PropTypes.bool,

    /** Optional class to throw on the node
       */
    className: PropTypes.string,

    /** Function to call when the item is clicked.
       The open state of the item will always be toggled.
       */
    callback: PropTypes.func
  }).isRequired),

  /** The readable label for the item
     */
  label: PropTypes.string.isRequired,

  /** A unique ID
     */
  id: PropTypes.string.isRequired,

  /** An icon to use on the left of the label
     */
  icon: PropTypes.element,

  /** Display a differnt icon when the item is expanded.
    For instance, an open folder or a down arrow
    */
  iconWhenExpanded: PropTypes.element,

  /** Use an empty icon to keep items without an icon
    lined up with their siblings
    */
  useEmptyIcon: PropTypes.bool,

  /** Whether or not the item is expanded.
     */
  isExpanded: PropTypes.bool,

  /** Optional class to throw on the node
     */
  className: PropTypes.string,

  /** Function to call when the item is clicked.
     The open state of the item will always be toggled.
     */
  callback: PropTypes.func
};

try {
  // @ts-ignore
  EuiTreeViewNode.displayName = "EuiTreeViewNode"; // @ts-ignore

  EuiTreeViewNode.__docgenInfo = {
    "description": "",
    "displayName": "EuiTreeViewNode",
    "props": {
      "children": {
        "defaultValue": null,
        "description": "An array of EuiTreeViewNodes to render as children",
        "name": "children",
        "required": false,
        "type": {
          "name": "string | number | boolean | {} | ReactElement<any, string | ((props: any) => ReactElement<any, string | ... | (new (props: any) => Component<any, any, any>)> | null) | (new (props: any) => Component<...>)> | ... 4 more ... | undefined"
        }
      },
      "label": {
        "defaultValue": null,
        "description": "The readable label for the item",
        "name": "label",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "id": {
        "defaultValue": null,
        "description": "A unique ID",
        "name": "id",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "icon": {
        "defaultValue": null,
        "description": "An icon to use on the left of the label",
        "name": "icon",
        "required": false,
        "type": {
          "name": "ReactElement<any, string | ((props: any) => ReactElement<any, string | ... | (new (props: any) => Component<any, any, any>)> | null) | (new (props: any) => Component<any, any, any>)> | undefined"
        }
      },
      "iconWhenExpanded": {
        "defaultValue": null,
        "description": "Display a differnt icon when the item is expanded.\nFor instance, an open folder or a down arrow",
        "name": "iconWhenExpanded",
        "required": false,
        "type": {
          "name": "ReactElement<any, string | ((props: any) => ReactElement<any, string | ... | (new (props: any) => Component<any, any, any>)> | null) | (new (props: any) => Component<any, any, any>)> | undefined"
        }
      },
      "useEmptyIcon": {
        "defaultValue": null,
        "description": "Use an empty icon to keep items without an icon\nlined up with their siblings",
        "name": "useEmptyIcon",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "isExpanded": {
        "defaultValue": null,
        "description": "Whether or not the item is expanded.",
        "name": "isExpanded",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "Optional class to throw on the node",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "callback": {
        "defaultValue": null,
        "description": "Function to call when the item is clicked.\nThe open state of the item will always be toggled.",
        "name": "callback",
        "required": false,
        "type": {
          "name": "(() => string) | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src-docs/src/views/tree_view/tree_view_props.tsx#EuiTreeViewNode"] = {
      docgenInfo: EuiTreeViewNode.__docgenInfo,
      name: "EuiTreeViewNode",
      path: "src-docs/src/views/tree_view/tree_view_props.tsx#EuiTreeViewNode"
    };
} catch (__react_docgen_typescript_loader_error) {}